import { render, staticRenderFns } from "./Finances.vue?vue&type=template&id=f4fb6864"
import script from "./Finances.vue?vue&type=script&lang=ts"
export * from "./Finances.vue?vue&type=script&lang=ts"
import style0 from "./Finances.vue?vue&type=style&index=0&id=f4fb6864&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports